// extracted by mini-css-extract-plugin
export default {"content":"styles_content__usRS+","chart":"styles_chart__3zPlg","yAxisLabel":"styles_yAxisLabel__V2hbD","xAxisLabel":"styles_xAxisLabel__ikQZp","isTest":"styles_isTest__XHJN9"};